export default __webpack_public_path__ + "11f90e99de8541983d9bcaceb4da7e87.png";